// src/components/SpotlightCursor.js
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const CursorGlow = styled.div.attrs(props => ({
  style: {
    left: `${props.$position.x}px`,
    top: `${props.$position.y}px`,
  },
}))`
  pointer-events: none;
  position: fixed;
  z-index: 9999;
  width: 800px;
  height: 800px;
  transform: translate(-50%, -50%);
  background: radial-gradient(circle, rgba(61, 90, 254, 0.1), transparent 60%);
  transition: opacity 0.3s ease;
  opacity: ${props => (props.$visible ? 1 : 0)};
`;

const SpotlightCursor = () => {
  const [position, setPosition] = useState({ x: -100, y: -100 });
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const updateMousePosition = (ev) => {
      setPosition({ x: ev.clientX, y: ev.clientY });
    };

    const handleMouseEnter = () => setVisible(true);
    const handleMouseLeave = () => setVisible(false);

    window.addEventListener('mousemove', updateMousePosition);
    document.body.addEventListener('mouseenter', handleMouseEnter);
    document.body.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      window.removeEventListener('mousemove', updateMousePosition);
      document.body.removeEventListener('mouseenter', handleMouseEnter);
      document.body.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  return <CursorGlow $position={position} $visible={visible} />;
};

export default SpotlightCursor;
